import { render, staticRenderFns } from "./PaidMemberPrice.vue?vue&type=template&id=1b041fd1&"
import script from "./PaidMemberPrice.vue?vue&type=script&lang=ts&"
export * from "./PaidMemberPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports